import { Typography } from "@material-ui/core"
import React, { Fragment, useState, useEffect } from "react"
import useStyles from "./styles"
import PropTypes from "prop-types"
import FromOrganizationSelect from "./FromOrganizationSelect/index"
import convertAdeskToOrganization, {
  organizationOptions,
} from "../../../../utils/convertAdeskToOrganization"

// if current user is adesk, gives select to choose gtt or crewmama
//  otherwise, just uses api data
const SelectOrganizationHeader = ({
  headerInfo,
  changeCompanyFn = () => { },
  clientView = false,
  working = false,
}) => {
  const classes = useStyles()
  const [companyValue, setCompanyValue] = useState("")
  const { crewmama_or_gtt } = headerInfo

  useEffect(
    () => {
      if (crewmama_or_gtt) {
        setCompanyValue(crewmama_or_gtt)
      }
    },
    [crewmama_or_gtt]
  )

  return (
    <Fragment>
      {clientView ? (
        // Show only company name if client view
        <Typography align="left" id="test" className={classes.data}>
          {companyValue && convertAdeskToOrganization(companyValue)}
        </Typography>
      ) : (
        <FromOrganizationSelect
          selectOptions={organizationOptions}
          headerInfo={headerInfo}
          changeCompanyFn={changeCompanyFn}
          stateValue={companyValue}
          setStateValue={setCompanyValue}
          working={working}
        />
      )}
    </Fragment>
  )
}

SelectOrganizationHeader.propTypes = {
  headerInfo: PropTypes.object.isRequired,
  changeCompanyFn: PropTypes.func,
  clientView: PropTypes.bool,
  working: PropTypes.bool,
}

export default SelectOrganizationHeader
